"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShieldedAmountAfterFee = exports.getShieldFee = exports.getAmountToUnshieldForTarget = exports.getUnshieldedAmountAfterFee = exports.getUnshieldFee = void 0;
const railgun_config_1 = require("../models/railgun-config");
const getUnshieldFee = (networkName, preUnshieldAmount) => {
    const unshieldFeeBasisPoints = railgun_config_1.RailgunConfig.getUnshieldFeeBasisPoints(networkName);
    return (preUnshieldAmount * unshieldFeeBasisPoints) / 10000n;
};
exports.getUnshieldFee = getUnshieldFee;
const getUnshieldedAmountAfterFee = (networkName, preUnshieldAmount) => {
    const fee = (0, exports.getUnshieldFee)(networkName, preUnshieldAmount);
    return preUnshieldAmount - fee;
};
exports.getUnshieldedAmountAfterFee = getUnshieldedAmountAfterFee;
const getAmountToUnshieldForTarget = (networkName, postUnshieldAmount) => {
    const unshieldFeeBasisPoints = railgun_config_1.RailgunConfig.getUnshieldFeeBasisPoints(networkName);
    return (postUnshieldAmount * 10000n) / (10000n - unshieldFeeBasisPoints);
};
exports.getAmountToUnshieldForTarget = getAmountToUnshieldForTarget;
const getShieldFee = (networkName, preShieldAmount) => {
    const shieldFeeBasisPoints = railgun_config_1.RailgunConfig.getShieldFeeBasisPoints(networkName);
    return (preShieldAmount * shieldFeeBasisPoints) / 10000n;
};
exports.getShieldFee = getShieldFee;
const getShieldedAmountAfterFee = (networkName, preShieldAmount) => {
    const fee = (0, exports.getShieldFee)(networkName, preShieldAmount);
    return preShieldAmount - fee;
};
exports.getShieldedAmountAfterFee = getShieldedAmountAfterFee;
